export default __webpack_public_path__ + "static/media/MaterialMetal_05.dd9871a2.png";